// extracted by mini-css-extract-plugin
module.exports = {"circle":"RatingCircle_circle__3vbzx"};